<template>
  <section class="h-full p-3">
    <div class="shadow p-3 pb-0 min-h-full mb-12 rounded-lg">
      <h6 class="text-xl font-semibold leading-normal mt-0 mb-4 text-gray-dark">
        Active
      </h6>
      <!-- <TrainerActive :data="formatData(trainerActiveSessionsData)" /> -->
      <!-- has course too -->
      <div
        class="grid md:grid-cols-3 grid-cols-2 gap-4"
        v-if="trainerActiveSessionsData && trainerActiveSessionsData.length"
      >
        <div v-for="(d, i) in trainerActiveSessionsData" :key="i">
          <router-link
            :to="{
              name: 'UserSessionDetails',
              params: { id: d.id },
            }"
          >
            <SessionCard :data="d" />
          </router-link>
        </div>
      </div>
      <Pagination
        v-if="totalPages"
        :currentPage="currentPage"
        :handlePageChange="handlePageChange"
        :totalPages="totalPages"
      />
      <div
        v-if="
          !(trainerActiveSessionsData && trainerActiveSessionsData.length) &&
          !loadingStatus
        "
        class="flex flex-col justify-center items-center text-xl text-gray-700 mt-8 space-y-8"
      >
        <img
          :src="require(`@/assets/img/my_sessions_no_data.svg`)"
          alt="..."
          class="w-72"
        />
        <div class="flex flex-col justify-center items-center text-center">
          <span> Looks like there is nothing here yet.</span>
          <span
            >Follow the Trainer to receive updates when new Classes are
            ready.</span
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import TrainerActive from "@/components/user/trainer/TrainerActive";
import SessionCard from "@/components/SessionCard";
import { Pagination } from "@/components/t-components";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "TrainerActiveSessionCardList",
  components: {
    // TrainerActive,
    SessionCard,
    Pagination,
  },
  data() {
    return {
      trainerActiveSessionsData: [],
      currentPage: 1,
      totalPages: "",
    };
  },
  computed: {
    ...mapGetters(["trainerActiveSessions"]),

    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
  },
  methods: {
    ...mapActions(["getTrainerActiveSessions"]),

    async handlePageChange(page) {
      // duplicate code
      this.currentPage = page;
      const query = {
        page,
      };
      this.trainerActiveSessionsData = [];
      this.totalPages = "";
      await this.getTrainerActiveSessions({
        id: this.$route.params.trainer_id,
        query,
      });
      this.trainerActiveSessionsData =
        this.trainerActiveSessions.data && this.trainerActiveSessions.data.data;
      this.totalPages =
        this.trainerActiveSessions.data &&
        this.trainerActiveSessions.data.last_page;
    },

    // formatData(data) {
    //   if (data) {
    //     if (Array.isArray(data)) {
    //       return data;
    //     }
    //     return Object.values(data);
    //   }
    //   return [];
    // },
  },
  async created() {
    const query = {
      page: this.currentPage,
    };
    const data = {
      id: this.$route.params.trainer_id,
      sessionId: 0,
    };
    await this.getTrainerActiveSessions({ data, query });
    this.trainerActiveSessionsData =
      this.trainerActiveSessions.data && this.trainerActiveSessions.data.data;
    this.totalPages =
      this.trainerActiveSessions.data &&
      this.trainerActiveSessions.data.last_page;
  },
};
</script>